/* eslint-disable react-hooks/exhaustive-deps */
import L from 'leaflet'
import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet/dist/leaflet.css'
import { useContext, useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { ImageOverlay, MapContainer, Rectangle, useMap } from 'react-leaflet'
import { io } from 'socket.io-client'
import api from '../../config/AxiosInstance'
import { UserContext } from '../../context/userContext'
import '../../styles/style.css'
import toast, { Toaster } from 'react-hot-toast'

const MapResizer = () => {
  const map = useMap()
  useEffect(() => {
    const handleResize = () => {
      map.invalidateSize()
      map.fitBounds(
        [
          [0, 0],
          [1000, 1000]
        ],
        { animate: false }
      )
    }

    const timeoutId = setTimeout(handleResize, 100)

    window.addEventListener('resize', handleResize)
    return () => {
      clearTimeout(timeoutId)
      window.removeEventListener('resize', handleResize)
    }
  }, [map])
  return null
}

function IndexMover(props) {
  const [data, setData] = useState(null)
  const [coordinates, setCoordinates] = useState([])
  const [suggestionItems, setSuggestionItems] = useState([])
  const [state] = useContext(UserContext)
  const socket = io.connect(
    process.env.REACT_APP_SOCKET_API_URL || 'https://bajnewbe.3qt9.lyr.id/'
  )

  useEffect(() => {
    fetchMe()
  }, [])

  useEffect(() => {
    socket.on(`${state?.username?.username}`, (response) => {
      let finalCoordinates = []
      let finalSuggestions = null

      let payload = response
      if (response && response.data) {
        payload = response.data
      }

      if (payload?.type === 'out') {
        const suggests = payload.suggests || []
        finalCoordinates = suggests.reduce((acc, curr) => {
          if (curr?.coordinate) {
            acc.push(curr.coordinate)
          }
          return acc
        }, [])
        finalSuggestions = suggests
      } else if (payload?.type === 'in' && payload?.suggest) {
        const categories = payload.suggest
        finalSuggestions = categories

        Object.keys(categories).forEach((key) => {
          if (Array.isArray(categories[key])) {
            categories[key].forEach((slot) => {
              if (slot?.coordinate) {
                finalCoordinates.push(slot.coordinate)
              }
            })
          }
        })
      } else if (
        payload &&
        typeof payload === 'object' &&
        !Array.isArray(payload) &&
        (payload.selective ||
          payload.shelving ||
          payload.ground_floor ||
          payload.double)
      ) {
        const categories = payload
        finalSuggestions = categories

        Object.keys(categories).forEach((key) => {
          if (Array.isArray(categories[key])) {
            categories[key].forEach((slot) => {
              if (slot?.coordinate) {
                finalCoordinates.push(slot.coordinate)
              }
            })
          }
        })
      } else if (Array.isArray(payload)) {
        finalCoordinates = payload.reduce((accumulator, currentValue) => {
          if (currentValue?.coordinate) {
            accumulator.push(currentValue.coordinate)
          }
          return accumulator
        }, [])
        finalSuggestions = payload
      }

      setCoordinates(finalCoordinates)
      setSuggestionItems(finalSuggestions)
    })
    return () => {
      socket.off(`${state?.username?.username}`)
    }
  }, [socket, state?.username?.username])

  const fetchMe = async () => {
    try {
      const res = await api.get('users/me')
      const { mobile } = res.data.data
      setData(mobile)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  return (
    <div style={{ height: 'calc(100vh - 110px)' }}>
      <Toaster />
      <Container fluid className="px-0 h-100">
        <Row className="g-4 h-100">
          <Col lg={9} className="h-100">
            <div className="card shadow border-0 rounded-4 overflow-hidden h-100">
              <div className="card-body p-0 card-map-pnp h-100">
                <div className="leaflet-map-container h-100">
                  <MapContainer
                    bounds={[
                      [0, 0],
                      [1000, 1000]
                    ]}
                    crs={L.CRS.Simple}
                    scrollWheelZoom={false}
                    doubleClickZoom={false}
                    touchZoom={false}
                    boxZoom={false}
                    keyboard={false}
                    dragging={false}
                    zoomSnap={0}
                    minZoom={-10}
                    style={{
                      height: '100%',
                      width: '100%',
                      background: '#e5e5e5'
                    }}
                    zoomControl={false}
                  >
                    <ImageOverlay
                      url={
                        !data
                          ? 'http://www.lib.utexas.edu/maps/historical/newark_nj_1922.jpg'
                          : data?.warehouse_map
                      }
                      bounds={[
                        [0, 0],
                        [1000, 1000]
                      ]}
                    />
                    {coordinates.length > 0 &&
                      coordinates?.map((coordinate, i) => (
                        <Rectangle
                          bounds={coordinate}
                          color="#F89D1D"
                          weight={2}
                          fillColor={'#F89D1D'}
                          fillOpacity={0.4}
                          key={i}
                        ></Rectangle>
                      ))}
                    <MapResizer />
                  </MapContainer>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={3} className="h-100">
            <div className="d-flex flex-column bg-white rounded-4 shadow p-0 overflow-hidden h-100">
              <div className="p-4 border-bottom bg-white sticky-top">
                {suggestionItems &&
                Array.isArray(suggestionItems) &&
                suggestionItems.length > 0 ? (
                  <div>
                    <h5 className="fw-bold mb-0 text-dark">
                      {suggestionItems[0]?.item || 'Unknown Item'}
                      {suggestionItems[0]?.pack &&
                        suggestionItems[0]?.pack !== 'empty' &&
                        ` • ${suggestionItems[0].pack}`}
                    </h5>
                  </div>
                ) : (
                  <h5 className="fw-bold mb-0 text-muted">Suggested Slots</h5>
                )}
              </div>

              <div
                className="d-flex flex-column flex-grow-1 p-3 bg-light"
                style={{ overflowY: 'auto' }}
              >
                {!suggestionItems ||
                (Array.isArray(suggestionItems) &&
                  suggestionItems.length === 0) ? (
                  <div className="text-center text-muted py-5 d-flex flex-column align-items-center opacity-50">
                    <p
                      className="mb-0 fw-medium"
                      style={{ fontSize: '1.2rem' }}
                    >
                      No recommended destination slots
                    </p>
                  </div>
                ) : !Array.isArray(suggestionItems) ? (
                  Object.keys(suggestionItems).map((category, idx) => (
                    <div key={idx} className="mb-4">
                      <h6
                        className="fw-bold text-uppercase text-muted mb-3"
                        style={{ fontSize: '0.8rem', letterSpacing: '1px' }}
                      >
                        {category?.replace('_', ' ')}
                      </h6>
                      <div className="row g-2">
                        {Array.isArray(suggestionItems[category]) &&
                        suggestionItems[category].length > 0 ? (
                          suggestionItems[category].map((slot, sIdx) => (
                            <div key={sIdx} className="col-6">
                              <button
                                className="btn btn-white w-100 h-100 py-2 px-1 border shadow-sm rounded-3 fw-medium text-dark text-break"
                                style={{
                                  fontSize: '1rem',
                                  backgroundColor: '#fff'
                                }}
                              >
                                {slot?.slot_code || '-'}
                              </button>
                            </div>
                          ))
                        ) : (
                          <div className="col-12 text-center py-2 text-muted small opacity-50">
                            NO DATA
                          </div>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <div>
                    <div className="row g-2">
                      {suggestionItems.map((item, idx) => (
                        <div key={idx} className="col-6">
                          <button
                            className="btn btn-white w-100 h-100 py-2 px-1 border shadow-sm rounded-3 fw-medium text-dark text-break"
                            style={{
                              fontSize: '1.5rem',
                              backgroundColor: '#fff'
                            }}
                          >
                            {item?.code || '-'}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}
export default IndexMover
